module.exports = __webpack_public_path__ + "static/media/avatar.4b9ec85f.jpg";